export default "__VITE_ASSET__Czypd$$e__"